import { useIntl } from 'localization';

import { C, ThresholdConfig, formatRatePct, rateSeverity } from '../../MapSharedData';
import { AggregatedRegion, RegionTooltip } from '../types';

interface Props {
  tooltip: RegionTooltip & { data: AggregatedRegion };
  cfg: ThresholdConfig;
}

export function RegionTooltipCard({ tooltip, cfg }: Props) {
  const { formatMessage } = useIntl();
  const { total, sent } = tooltip.data;
  const sev = rateSeverity(total, sent, cfg);

  return (
    <div
      className="fixed rounded-10 px-3.5 py-2.5 text-[13px] pointer-events-none z-[9999] shadow-popup min-w-[200px] max-w-[280px]"
      style={{ left: tooltip.x + 14, top: tooltip.y - 10, background: C.textPrimary, color: C.bg }}
    >
      <div className="font-semibold mb-1 text-sm">{tooltip.name}</div>
      {sev.insufficient ? (
        <div className="mb-2" style={{ color: sev.color }}>
          {formatMessage({ id: sev.labelId })}
          {sent != null && (
            <span className="text-[11px] text-v2blueGray-400">
              {' · '}
              {formatMessage(
                { id: 'analytics.incidentMap.ordersRatio' },
                { count: total.toLocaleString(), total: sent.toLocaleString() },
              )}
            </span>
          )}
        </div>
      ) : (
        <>
          {sent != null ? (
            <div className="mb-0.5" style={{ color: sev.color }}>
              <span className="font-semibold">{formatRatePct(total, sent)}</span>{' '}
              <span className="text-[11px] text-v2blueGray-400">
                {formatMessage(
                  { id: 'analytics.incidentMap.ordersRatio' },
                  { count: total.toLocaleString(), total: sent.toLocaleString() },
                )}
              </span>
            </div>
          ) : (
            <div className="mb-0.5" style={{ color: sev.color }}>
              {formatMessage({ id: 'analytics.incidentMap.ordersCount' }, { count: total })}
            </div>
          )}
          <div className="text-[11px] mb-2" style={{ color: sev.color }}>
            {formatMessage({ id: sev.labelId })}
          </div>
        </>
      )}
      <div className="text-[11px] text-v2blueGray-500 italic mt-1">
        {formatMessage({ id: 'analytics.incidentMap.tooltip.clickZoom' })}
      </div>
    </div>
  );
}
